
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"12","viewBox":"0 0 7 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.804.333c-.05.004-.063.003-.113.012a.836.836 0 00-.447.232l-5 5c-.035.037-.045.046-.075.086a.834.834 0 000 1.007c.03.04.04.049.074.086l5 5c.038.034.046.044.086.075a.836.836 0 00.862.088.84.84 0 00.436-1.004.835.835 0 00-.13-.252c-.03-.04-.04-.049-.075-.086l-4.41-4.41 4.41-4.412.04-.041c.03-.04.04-.048.068-.09A.835.835 0 005.975.344C5.925.336 5.912.337 5.86.333h-.056z","fill":"#44474A"}})])
          )
        }
      }
    